// Preprod UI deployment configuration
import { setTarget } from '@inboundx/shared/config';

// Set deployment target for preprod
setTarget('preprod');
